<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar una nueva campaña</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Fecha de Inicio (*) </label>

                <el-date-picker
                  ref="startDate"
                  v-model="formData.startDate"
                  v-validate="modelValidations.startDate"
                  align="center"
                  :editable="false"
                  :picker-options="pickerOptions"
                  format="dd-MM-yyyy"
                  name="startDate"
                  placeholder="Fecha de Inicio"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="startDate.invalid" class="text-danger">
                  {{ getError('startDate') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Fecha de Fin (*) </label>

                <el-date-picker
                  v-model="formData.endDate"
                  v-validate="modelValidations.endDate"
                  align="center"
                  :disabled="!Boolean(formData.startDate)"
                  :picker-options="{ ...pickerOptions, disabledDate: disabledDate }"
                  format="dd-MM-yyyy"
                  name="endDate"
                  placeholder="Fecha de Fin"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="endDate.invalid" class="text-danger">
                  {{ getError('endDate') }}
                </small>
              </div>
            </div>

            <div v-if="withCrops" class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Cultivos (*) </label>

                <el-select
                  v-model="formData.crops"
                  v-validate="modelValidations.crops"
                  autocomplete="off"
                  filterable
                  multiple
                  name="crops"
                  placeholder="Cultivos"
                >
                  <el-option
                    v-for="option in cropsOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="crops.invalid" class="text-danger">
                  {{ getError('crops') }}
                </small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from 'element-ui';
import { mapFields } from 'vee-validate';
import moment from 'moment';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  props: {
    campaign: {
      type: Object,
      default: () => {
        return {
          name: null,
          crops: null,
          startDate: '',
          endDate: '',
        };
      },
    },

    withCrops: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: 'Hoy',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: 'Próx. 6 Meses',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit('pick', date);
            },
          },
          {
            text: 'Próximo Año',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            },
          },
        ],
      },

      cropsList: [],
      validated: false,
      formData: {
        name: this.campaign.name,
        crops: this.campaign.crops,
        startDate: this.campaign.from,
        endDate: this.campaign.to,
      },

      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        startDate: {
          required: true,
        },

        endDate: {
          required: true,
        },

        crops: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'startDate', 'endDate', 'crops']),
    cropsOptions() {
      return this.$selectOptions(this.cropsList, { sort: true });
    },

    disabledDate() {
      return (date) =>
        this.formData.startDate
          ? date <= moment(this.formData.startDate).toDate()
          : date < moment().subtract(100, 'y').toDate();
    },
  },

  created() {
    if (this.withCrops) {
      this.fetchCrops();
    }
  },

  methods: {
    fetchCrops() {
      this.$services
        .resource('crops')
        .get()
        .then((res) => res.data.data)
        .then((data) => (this.cropsList = data.crops));
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
